module.exports = __webpack_public_path__ + "static/media/error_system.861e05aa.png";